import React from "react";
import _ from "lodash";
import PriceSettingControl from "./PriceSettingControl";
import PriceSettingsTable from "./PriceSettingsTable";

class PriceSettingsSection extends React.PureComponent {
  constructor(props) {
    super(props);

    const { priceSettings } = this.props;

    this.state = {
      isEditing: false,
      currentSetting: null,
      priceSettings,
      currentIndexInSettings: null, // for edit and remove
    };

    this.handleOpenEdit = this.handleOpenEdit.bind(this);
    this.handleAddSetting = this.handleAddSetting.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleOpenDuplicate = this.handleOpenDuplicate.bind(this);
  }

  handleOpenEdit({ setting }, index) {
    const currentSetting = setting || {};
    this.setState({
      isEditing: true,
      currentSetting,
      currentIndexInSettings: index,
    });
    if (this.props.handleIsEditing) this.props.handleIsEditing(true);
  }

  handleRemove(item, index) {
    const { priceSettings } = this.state;
    const newSettings = _.cloneDeep(priceSettings) || [];
    newSettings.splice(index, 1);

    this.setState({
      priceSettings: newSettings,
    });
    if (this.props.handlePriceSettingsChanged)
      this.props.handlePriceSettingsChanged(newSettings);
  }

  handleOpenDuplicate(item) {
    const newItem = _.cloneDeep(item);
    if (item.isSetForEverything) {
      newItem.isSetForEverything = false;
    }
    this.setState({ isEditing: true, currentSetting: newItem });
    if (this.props.handleIsEditing) this.props.handleIsEditing(true);
  }

  handleCancel() {
    this.setState({
      isEditing: false,
      currentSetting: null,
      currentIndexInSettings: null,
    });

    if (this.props.handleIsEditing) this.props.handleIsEditing(false);
  }

  handleAddSetting(newSetting) {
    const { currentIndexInSettings } = this.state;
    const { handlePriceSettingsChanged, handleIsEditing } = this.props;
    let newSettings = _.cloneDeep(this.props.priceSettings) || [];
    if (!_.isNil(currentIndexInSettings)) {
      newSettings[currentIndexInSettings] = newSetting;
    } else {
      newSettings.push(newSetting);
    }

    newSettings = _.orderBy(newSettings, ["isSetForEverything"], ["asc"]);

    this.setState({
      priceSettings: newSettings,
      isEditing: false,
      currentIndexInSettings: null,
    });

    if (handlePriceSettingsChanged) handlePriceSettingsChanged(newSettings);
    if (handleIsEditing) handleIsEditing(false);
  }

  render() {
    const { currency, networkId, priceSettings } = this.props;
    const { isEditing, currentSetting } = this.state;

    const isSetForEverythingExist =
      _.find(priceSettings, (setting) => setting.isSetForEverything) &&
      currentSetting &&
      !currentSetting.isSetForEverything;

    return (
      <div>
        {!isEditing && (
          <button
            type="button"
            className="rounded shadow mb-2 bg-blue-100 px-2 py-1 text-sm text-blue-600 hover:bg-blue-200"
            onClick={this.handleOpenEdit}
          >
            Create new price setting
          </button>
        )}

        {isEditing && (
          <PriceSettingControl
            networkId={networkId}
            currency={currency}
            isSetForEverythingExist={isSetForEverythingExist}
            currentSetting={currentSetting}
            handleAddSetting={this.handleAddSetting}
            handleCancel={this.handleCancel}
          ></PriceSettingControl>
        )}

        {priceSettings && (
          <PriceSettingsTable
            items={priceSettings}
            networkId={networkId}
            isEditing={isEditing}
            handleEdit={this.handleOpenEdit}
            handleRemove={this.handleRemove}
            handleOpenDuplicate={this.handleOpenDuplicate}
          ></PriceSettingsTable>
        )}
      </div>
    );
  }
}

export default PriceSettingsSection;
